import { ResponseType } from "./GenericOptions";
import { GenericRequest } from "./GenericRequest";

export class HttpRequest {
  get<T>(url: string, params: any, headers?: any, responseType?: ResponseType): Promise<T> {
    const options: GenericRequest = {
      method: "GET",
      url,
      options: { params, headers, responseType },
    };
    return this.requestAll<T>(options);
  }
  post<T, K>(
    url: string,
    body?: T,
    headers?: any,
    params?: any,
    responseType?: ResponseType
  ): Promise<K> {
    const options: GenericRequest = {
      method: "POST",
      url,
      options: { params, body, headers, responseType },
    };
    return this.requestAll<K>(options);
  }
  patch<T, K>(
    url: string,
    body: T,
    params?: any,
    headers?: any,
    responseType?: ResponseType
  ): Promise<K> {
    const options: GenericRequest = {
      method: "PATCH",
      url,
      options: { params, headers, body, responseType },
    };
    return this.requestAll<K>(options);
  }
  put<T, K>(
    url: string,
    body: T,
    params?: any,
    headers?: any,
    responseType?: ResponseType
  ): Promise<K> {
    const options: GenericRequest = {
      method: "PUT",
      url,
      options: { params, headers, body, responseType },
    };
    return this.requestAll<K>(options);
  }
  delete<T>(url: string, headers?: any, responseType?: ResponseType): Promise<T> {
    const options: GenericRequest = {
      method: "DELETE",
      url,
      options: { headers, responseType },
    };
    return this.requestAll<T>(options);
  }
  requestAll<T>(requestOptions: GenericRequest): Promise<T> {
    const { method, url, options } = requestOptions;
    let others = {};
    if (options.headers !== "none") {
      others = {
        ...others,
        headers: {
          "Content-Type": "application/json",
        },
      };
    }

    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_BASE_URL + url, {
        ...others,
        method: method,
        body: options?.body?.formData || JSON.stringify(options?.body),
      })
        .then((response) => {
          response
            .json()
            .then((json) => {
              if (json.status === "error") {
                reject(json.msg);
              } else {
                if (json.data) {
                  resolve(json);
                } else {
                  resolve(json);
                }
              }
            })
            .catch((err) => {
              reject(err.msg);
            });
        })
        .catch((err) => {
          // Sin este catch un fallo de red deja la promesa pendiente para siempre.
          reject(err?.message || err);
        });
    });
  }
}
